module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-7.eff54117.jpg";